/**
 * Gets the app name that's currently in use.
 *
 * @return {string}
 */
export default () => {
  const path = document.location.pathname;
  return path.split('/')[1];
};
